import { versionedImageUrl } from "@/lib/image-version"
import { useState } from "react"
import { initialsOf } from "@nl/shared"
import { cn } from "@/lib/utils"

export function ConversationPortrait({ portraitUrl, name, className }: {
  portraitUrl?: string | null
  name: string
  className?: string
}) {
  const [failed, setFailed] = useState<string[]>([])
  const tile = portraitUrl?.replace(/^\/(personas|coaches)\//, "/$1/kacheln/")
  const src = [tile, portraitUrl].find((url) => url && !failed.includes(url))
  return (
    <div className={cn("shrink-0 overflow-hidden bg-accent", className)}>
      {src ? (
        <img src={versionedImageUrl(src)} alt={name} onError={() => setFailed((urls) => [...urls, src])}
          className="h-full w-full object-cover object-[50%_22%]" />
      ) : (
        <div className="flex h-full items-center justify-center font-display text-5xl text-primary">{initialsOf(name)}</div>
      )}
    </div>
  )
}
